/** @file toggleProfilePitch: Numpad5 and the cube centre, between the profile pitch and the pitch before it. */
import type { EditorStore } from '../../state/editorTypes';
import { profilePitchToggle } from './profilePitchToggle';

/** The pitch to go back to, per store (view state: never in the document or undo). */
const saved = new WeakMap<EditorStore, number | null>();

/** `profilePitchToggle` on the store's camera, remembering the pitch to return to between the key and the cube. */
export function toggleProfilePitch(store: EditorStore, profilePitchDeg: number): void {
  const next = profilePitchToggle(store.getState().camera.pitchDeg, profilePitchDeg, saved.get(store) ?? null);
  saved.set(store, next.saved);
  store.getState().setCamera({ pitchDeg: next.pitchDeg });
}
